export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf01-de.cddc12ca.png";